module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up reset-password"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', {
    attrs: {
      "user-signup": ""
    }
  }, [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [(_vm.resetCodeUrl == 'email') ? _c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        _vm.initiatePasswordReset(_vm.userEmail)
      }
    }
  }, [(_vm.emailsent) ? [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("You've got mail!")]), _vm._v(" "), _c('p', [_vm._v("We sent an email to " + _vm._s(_vm.userEmail) + ". Please click on the link in your email to "), (_vm.isRequestCard) ? [_vm._v("activate your account and")] : _vm._e(), _vm._v(" reset your password.")], 2), _vm._v(" "), _c('p', [_vm._v("If you cannot access this email, please contact Customer Care on 0861 668 437 for further assistance.")])] : [(_vm.isRequestCard) ? [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Send activation link")]), _vm._v(" "), _c('p', [_vm._v("If you joined SK Club at one of our cinemas, please enter your email address and we will send you a link to activate your membership.")])] : [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Password Reset")]), _vm._v(" "), _c('p', [_vm._v("Please enter your email address and we'll send you a link to create a new password.")])], _vm._v(" "), _c('sk-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "autocomplete": "email",
      "label": "Email",
      "placeholder": "e.g. xxx@gmail.com",
      "disabled": _vm.disabled == 1 ? true : false,
      "required": ""
    },
    model: {
      value: (_vm.userEmail),
      callback: function($$v) {
        _vm.userEmail = $$v
      },
      expression: "userEmail"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [(_vm.isRequestCard) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingReset
    }
  }, [_vm._v("Send Activation email")]) : _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingReset
    }
  }, [_vm._v("Reset My Password")])], 1), _vm._v(" "), _c('p', [(_vm.isRequestCard) ? [_vm._v("\n                Having trouble receiving your SK Club Activation email?\n              ")] : [_vm._v("\n                Can't access this email address?\n              ")], _vm._v("\n               Please contact Customer Care on "), (_vm.$breakpoints.xs) ? _c('a', {
    attrs: {
      "href": "tel:0861668437"
    }
  }, [_vm._v("0861 668 437")]) : _c('span', [_vm._v("0861 668 437")]), _vm._v(" for further assistance.")], 2)]], 2) : _vm._e(), _vm._v(" "), (_vm.codeVerified || _vm.resetCodeUrl == 'dev') ? _c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        _vm.completePasswordReset(_vm.newPassword, _vm.resetCodeUrl)
      }
    }
  }, [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Enter your new password")]), _vm._v(" "), _c('sk-input', {
    staticClass: "dark-input",
    attrs: {
      "name": "password",
      "autocomplete": "new-password",
      "label": "New Password",
      "disabled": _vm.disabled == 1 ? true : false,
      "type": "password",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your password.',
        patternMismatch: 'Your password must contain a minimum of 8 characters containing both numbers and letters, with at least one uppercase letter and a special character (!@#$%&). '
      },
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingReset
    }
  }, [_vm._v("Reset My Password")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  })], 1)], 1) : _vm._e()]], 2)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.noEmailDialog),
      callback: function($$v) {
        _vm.noEmailDialog = $$v
      },
      expression: "noEmailDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noEmailDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noEmailDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Whoops!")]), _vm._v(" "), _c('p', [(_vm.isRequestCard) ? [_vm._v("\n          This email does not exist on our site. Please contact Customer Care on 0861 668 437 for further assistance.\n        ")] : [_vm._v("\n          This email does not exist on our site. Please create a profile.\n        ")]], 2), _vm._v(" "), (_vm.isRequestCard) ? [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noEmailDialog = false
      }
    }
  }, [_vm._v("Got it")])] : [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": "/user/signup"
    }
  }, [_vm._v("Create a profile")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.noEmailDialog = false
      }
    }
  }, [_vm._v("Got it")])]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72cca263","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/user/password-reset.vue
// module id = 558
// module chunks = 0